import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  HiHome,
  HiUsers,
  HiArrowPath,
  HiUserPlus,
  HiDocumentPlus,
  HiArrowRightOnRectangle,
  HiArrowLeftOnRectangle,
} from "react-icons/hi2";

import classes from "./Nav.module.css";
import { authActions } from "../../store/auth-slice";
import { clearAuthToken } from "../../util/authToken";

const Nav = ({ onNavigate }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutHandler = () => {
    onNavigate?.();
    clearAuthToken();
    dispatch(authActions.logout());
    navigate("/", { replace: true });
  };

  return (
    <nav className={classes.nav}>
      <NavLink
        to="/"
        end
        className={(navData) => (navData.isActive ? classes.active : "")}
        onClick={onNavigate}
      >
        <HiHome className={classes.navIcon} aria-hidden />
        Home
      </NavLink>
      <NavLink
        to="/accounts"
        className={(navData) => (navData.isActive ? classes.active : "")}
        onClick={onNavigate}
      >
        <HiUsers className={classes.navIcon} aria-hidden />
        Accounts
      </NavLink>
      <NavLink
        to="/transactions"
        className={(navData) => (navData.isActive ? classes.active : "")}
        onClick={onNavigate}
      >
        <HiArrowPath className={classes.navIcon} aria-hidden />
        Transactions
      </NavLink>
      <NavLink
        to="/createAccount"
        className={(navData) => (navData.isActive ? classes.active : "")}
        onClick={onNavigate}
      >
        <HiUserPlus className={classes.navIcon} aria-hidden />
        Create account
      </NavLink>
      <NavLink
        to="/createTransaction"
        className={(navData) => (navData.isActive ? classes.active : "")}
        onClick={onNavigate}
      >
        <HiDocumentPlus className={classes.navIcon} aria-hidden />
        Create transaction
      </NavLink>
      {!isLoggedIn && (
        <NavLink
          to="/login"
          className={(navData) => (navData.isActive ? classes.active : "")}
          onClick={onNavigate}
        >
          <HiArrowRightOnRectangle className={classes.navIcon} aria-hidden />
          Login
        </NavLink>
      )}
      {isLoggedIn && (
        <button type="button" onClick={logoutHandler}>
          <HiArrowLeftOnRectangle className={classes.navIcon} aria-hidden />
          Logout
        </button>
      )}
    </nav>
  );
};

export default Nav;
